<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-podium</v-icon>{{$t('profile.score.benchmarks')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileBenchmarkForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfileBenchmarkForm from '../../components/profilebenchmark/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfileBenchmark';

const { mapFields } = createHelpers({
  getterType: 'profilebenchmark/getField',
  mutationType: 'profilebenchmark/updateField'
});

export default {
  name: 'ProfileBenchmarkCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileBenchmarkForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profilebenchmark', ['create', 'reset'])
  }
};
</script>
